import React from 'react';

/**
 * Creates a keyboard event handler that responds to Enter and Space keys
 * @param callback - The function to call when Enter or Space is pressed
 * @returns A keyboard event handler function
 */
export const createKeyboardHandler = (
    callback: () => void,
): ((event: React.KeyboardEvent) => void) => {
    return (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            callback();
        }
    };
};

/**
 * Creates a conditional keyboard event handler that only executes if a condition is met
 * @param callback - The function to call when Enter or Space is pressed
 * @param condition - Function that returns true if the callback should be executed
 * @returns A keyboard event handler function
 */
export const createConditionalKeyboardHandler = (
    callback: () => void,
    condition: () => boolean,
): ((event: React.KeyboardEvent) => void) => {
    return (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            if (condition()) {
                callback();
            }
        }
    };
};
